import { APP_PREFIX_PATH } from '@/constants/route.constant'
import { NAV_ITEM_TYPE_COLLAPSE, NAV_ITEM_TYPE_ITEM } from '@/constants/navigation.constant'
import generalNavigationConfig from '@/configs/navigation.config/general.navigation.config'

const userNavigationConfig = [
    ...generalNavigationConfig,
    {
        key: 'dashboard',
        path: `${APP_PREFIX_PATH}/`,
        title: 'داشبورد',
        translateKey: 'داشبورد',
        icon: 'TbDashboard',
        type: NAV_ITEM_TYPE_ITEM,
        permissions: [],
        subMenu: []
    },
    {
        key: 'relatives',
        path: `${APP_PREFIX_PATH}/relatives`,
        title: 'اسامی قابل رزرو',
        translateKey: 'اسامی قابل رزرو',
        icon: 'FaPeopleRoof',
        type: NAV_ITEM_TYPE_ITEM,
        permissions: [],
        subMenu: []
    },
    {
        key: 'hotels',
        path: `${APP_PREFIX_PATH}/hotels`,
        title: 'هتل‌ها',
        translateKey: 'هتل‌ها',
        icon: 'RiHotelLine',
        type: NAV_ITEM_TYPE_ITEM,
        permissions: [],
        subMenu: []
    },
    {
        key: 'tours',
        path: `${APP_PREFIX_PATH}/tours`,
        title: 'تورهای زیارتی و سیاحتی',
        translateKey: 'تورهای زیارتی و سیاحتی',
        icon: 'MdOutlineTravelExplore',
        type: NAV_ITEM_TYPE_ITEM,
        permissions: [],
        subMenu: [],
    },
    {
        key: 'reservations',
        path: `${APP_PREFIX_PATH}/reservations`,
        title: 'رزروهای قبلی',
        translateKey: 'رزروهای قبلی',
        icon: 'MdHistory',
        type: NAV_ITEM_TYPE_ITEM,
        permissions: [],
        subMenu: []
    },
    {
        key: 'support',
        path: `${APP_PREFIX_PATH}/support`,
        title: 'پشتیبانی',
        translateKey: 'پشتیبانی',
        icon: 'MdOutlineSupportAgent',
        type: NAV_ITEM_TYPE_ITEM,
        permissions: [],
        subMenu: []
    }
]

export default userNavigationConfig
